import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, ButtonGroup, Card, Col, Form, Image, Modal, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import {handleTimeAgo, isEmpty, navigate} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faInfo, faPlus, faSave} from "@fortawesome/free-solid-svg-icons";
import TextInput from "./input/TextInput";
import {withRouter} from 'react-router-dom';
import Global from "../utils/Global";
import SmartDeviceDetailPage from "../pages/subscribe/SmartDeviceDetailPage";


const maxBorrowingDurationOptions = [{id:1, label:label.NotLimited}, {id:2, label:label.Limited}];
class SmartDeviceInfoModal extends BaseComponent{

    constructor(props) {
        super(props);
        let {smartDevice} = this.props
        this.state = {
            smartDevice:smartDevice,
            show:false,
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!=this.props){
            let {smartDevice, show} = this.props
            this.setState({smartDevice, show}, () => {
                if(show){
                    // this.fetchGoodsCategories((goodsCategories)=>{
                    //     this.setState({goodsCategories})
                    // })
                }
            })
        }
    }

    render() {
        let {smartDevice, show} = this.state
        let smartDeviceStatus = smartDevice?.smartDeviceStatus?smartDevice?.smartDeviceStatus:{}
        let smartDeviceState = smartDevice?.smartDeviceState?smartDevice?.smartDeviceState:{}
        let spotLocation = smartDevice?.spotLocation?smartDevice?.spotLocation:{}
        return (
            <>
                {super.render()}
                <Modal as={Modal.Dialog} size="lg" centered show={show} onHide={()=>{}}>
                    <Modal.Header>
                        <Modal.Title className="h6">{label.SmartDevice}</Modal.Title>
                        <Button variant="close" aria-label="Close" onClick={()=>{
                            this.props.onClose()
                        }} />
                    </Modal.Header>
                    <Modal.Body>
                        <React.Fragment>
                            <Row>
                                <Col xs={6}>
                                    <Card border="light" className="bg-white shadow-sm mb-4 p-0">
                                        <Card.Header>
                                            <Row>
                                                <Col>
                                                    {label.Status}
                                                </Col>
                                                <Col className="text-right p-0">
                                                    <Button
                                                        variant="outline-warning"
                                                        size="sm"
                                                        style={{width:'24px',height:'24px'}}
                                                        className="rounded-circle p-0">
                                                        <FontAwesomeIcon style={{width:'12px',height:'12px'}} icon={faInfo} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="d-xl-flex align-items-center">
                                                <div className="user-avatar xl-avatar">
                                                    <Image fluid rounded src={Global.DEVICE_STATUS_ICONS[smartDeviceStatus.icon]} />
                                                </div>
                                                <div className="file-field">
                                                    <div className="d-flex justify-content-xl-center ms-xl-3">
                                                        <div className="d-flex">
                                                            <div className="d-md-block text-start">
                                                                <div className="fw-normal font-weight-bold mb-1 rounded px-2 text-white" style={{backgroundColor:smartDeviceStatus.color}}>{smartDeviceStatus.label}</div>
                                                                <div className="text-gray small">{label.UpdatedAt} {handleTimeAgo(smartDevice.updated)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                        <Card.Footer className="border-warning p-3">
                                            <span className="rounded pt-1 px-4 pb-1 text-white" style={{fontSize:'12px', fontStyle:'italic', fontWeight:'bold', backgroundColor:smartDeviceState.color}}>{smartDeviceState.label}</span>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                                <Col xs={6}>
                                    <Card border="light" className="bg-white shadow-sm mb-4">
                                        <Card.Header>
                                            <Row>
                                                <Col>
                                                    {label.Location}
                                                </Col>
                                                <Col className="text-right p-0">
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Card.Body>
                                            <div className="d-xl-flex align-items-center">
                                                <div className="user-avatar xl-avatar">
                                                    <Image fluid rounded src={ApplicationIcons.Icons.markerMap} />
                                                </div>
                                                <div className="file-field">
                                                    <div className="d-flex justify-content-xl-center ms-xl-3">
                                                        <div className="d-flex">
                                                            <div className="d-md-block text-start">
                                                                <div className="fw-normal font-weight-bold mb-1 rounded px-2">{!isEmpty(spotLocation.name)?spotLocation.name:label.NoInformation}</div>
                                                                <div className="text-gray small">{!isEmpty(spotLocation.phoneNumber)?spotLocation.phoneNumber:"-"}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                        <Card.Footer className="border-warning p-3">
                      <span className={!isEmpty(spotLocation.name)?"text-info":"text-danger"} style={{fontSize:'12px', fontStyle:'italic', fontWeight:'bold'}}>
                        {
                            isEmpty(spotLocation.name)? (label.PleaseFillUpDeviceLocated):(spotLocation.address+", "+spotLocation.regional)
                        }
                      </span>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form>
                                        <TextInput
                                            label={label.Label}
                                            required={true}
                                            value={smartDevice.label}
                                            disabled={true}
                                            readOnly={true}
                                        />
                                    </Form>
                                </Col>
                                <Col>
                                    <TextInput
                                        label={label.PublicIpAddress}
                                        required={true}
                                        value={smartDevice.publicIpAddress}
                                        disabled={true}
                                        readOnly={true}
                                    />
                                </Col>
                                <Col>
                                    <TextInput
                                        label={label.LocalIpAddress}
                                        required={true}
                                        value={smartDevice.localIpAddress}
                                        disabled={true}
                                        readOnly={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Form>
                                        <TextInput
                                            label={label.DeviceId}
                                            required={true}
                                            value={smartDevice.deviceId}
                                            disabled={true}
                                            readOnly={true}
                                        />
                                    </Form>
                                </Col>
                                <Col>
                                    <TextInput
                                        label={label.UUID}
                                        required={true}
                                        value={smartDevice.uuidCode}
                                        disabled={true}
                                        readOnly={true}
                                    />
                                </Col>
                                <Col>
                                    <TextInput
                                        label={label.ShortCode}
                                        required={true}
                                        value={smartDevice.shortCode}
                                        disabled={true}
                                        readOnly={true}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-right px-4 pb-2">
                                    <ButtonGroup>
                                        <Button
                                            size="sm"
                                            onClick={(event) => {
                                                // await this.submit()
                                                navigate(this.props, SmartDeviceDetailPage.ENDPOINT+"/"+smartDevice.deviceId+SmartDeviceDetailPage.INFO)
                                            }}>
                                            {label.SmartDeviceDetail}&nbsp;&nbsp;<FontAwesomeIcon icon={faInfo}/>
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </React.Fragment>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
SmartDeviceInfoModal.propTypes = {
    smartDevice:PropTypes.object.isRequired,
    onClose:PropTypes.func.isRequired,
    show:PropTypes.bool.isRequired
}

export default withRouter(SmartDeviceInfoModal)
